import { getUser } from '@/api/user';
const setItem = (key, value) => window.localStorage.setItem(key, value);
const userInfoLS = () => {
    return JSON.parse(window.localStorage.getItem('userInfo'));
};
const user = {
    state: {
        token: '',
        id: 0,
        username: '',
        account: '',
        expire_time: '',
        invitation_code: '',
        sound: window.localStorage.getItem('sound') == "true" ? true : false
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
            window.localStorage.setItem("userToken", token);
        },
        SET_ID: (state, id) => {
            state.id = id;
        },
        SET_USERNAME: (state, username) => {
            state.username = username;
        },
        SET_ACCOUNT: (state, account) => {
            state.account = account;
            window.localStorage.setItem("userAccount", account);
        },
        SET_SOUNDSTATUS: (state, sound) => {
            window.localStorage.setItem("sound", sound);
            state.sound = sound;          
        },
        SET_EXPIRE_TIME: (state, expire_time) => {
            state.expire_time = expire_time;
            window.localStorage.setItem("expireTime", expire_time || "");
        },
        SET_INVITATION_CODE: (state, invitation_code) => {
            state.invitation_code = invitation_code;
            window.localStorage.setItem("invitation_code", invitation_code || "");
        },
    },
    actions: {
        // 用户名登录
        getUserinfo({ commit }, state) {
            return new Promise((resolve, reject) => {
                getUser().then(response => {
                    if (response.data.code == 200 && response.data.data.token) {
                        commit('SET_TOKEN', response.data.data.token);
                        commit('SET_ACCOUNT', response.data.data.account);
                        commit('SET_EXPIRE_TIME', response.data.data.expire_time || "");
                        commit('SET_INVITATION_CODE', response.data.data.promo_code || "");
                    } else {
                        commit('SET_TOKEN', "");
                        commit('SET_ACCOUNT', "");
                        commit('SET_EXPIRE_TIME', "");
                        commit('SET_INVITATION_CODE', "");
                    }
                    resolve(response);
                }).catch(err => {
                    commit('SET_TOKEN', "");
                    commit('SET_ACCOUNT', "");
                    commit('SET_EXPIRE_TIME', "");
                    commit('SET_INVITATION_CODE', "");
                    reject(err);
                });
            });
        },
        // 登出
        logOut({ commit, state }) {
            state.token = "";
            state.account = "";
            state.expire_time = "";
            state.invitation_code = "";
            commit('SET_TOKEN', "");
            commit('SET_ACCOUNT', "");
            commit('SET_EXPIRE_TIME', "");
            commit('SET_INVITATION_CODE', "");
        },
    }
};

export default user;




// WEBPACK FOOTER //
// ./src/store/modules/user.js